import React from 'react';
import About from '../Components/About';
import Banner from '../Components/Banner';
import Enrollment from '../Components/Enrollment';
import Latest from '../Components/Latest';
import Announcement from './Announcement';
import img1 from '../img/jp/j1.png';
import img2 from '../img/jp/j2.png';
import img3 from '../img/jp/j3.png';
import img4 from '../img/jp/j4.png';
import img5 from '../img/jp/j5.png';
import img6 from '../img/jp/j6.png';
import img7 from '../img/jp/j7.png';
import img8 from '../img/jp/j8.png';
import img9 from '../img/jp/j9.png';

const Japanese = () => {
    
    const services = [
        {
            name: "JLPT study",
            img: img1,
            para: "The Japanese-Language Proficiency Test (日本語能力試験, Nihongo Nōryoku Shiken), or JLPT, is a standardized criterion-referenced test to evaluate and certify Japanese language proficiency for non-native speakers, covering language knowledge, reading ability, and listening ability. ",
            btn: "Enroll"
        },
        {
            name: "Business Japanese",
            img: img2,
            para: "It is very important to understand business Japanese before you plan to move or work in Japan. Japan is a very polite and sensitive country and in different settings, like business, casual, they speak differently. We teach you business Japanese and business adequately and help you to get a good score in BJT.",
            btn: "Enroll"
        },
        {
            name: "Support in Japan",
            img: img3,
            para: "Japan is a bucket lister’s paradise. It’s a place where traditional and modern culture mix to create something incomparable. There are experiences here unlike anywhere else, but if you come unprepared, you might miss out. We help you understand Japanese culture and let you explore the country with ease. ",
            btn: "Book"
        },
        {
            name: "Jobs in Japan",
            img: img4,
            para: "We provide different types of Job services in japan. Whether you are an IT engineer, constructor worker, manager or TITP intern, we have support for you to start your new working life in Japan. Enroll now and get started. ",
            btn: "Enroll"
        },
        {
            name: "Immigration Support",
            img: img5,
            para: "Immigration to Japan is not an easy process but we support you at every step of your application. One of the easiest ways to immigrate is to start working in Japan on a long term VISA. We also provide support for Japanese PR. Send us your inquiry now. ",
            btn: "Book now"
        },
        {
            name: "TITP",
            img: img7,
            para: "TITP is acronym of Technical Intern Training Program. This is a special type of VISA provided by Japanese immigration office for foreign intern workers in different sectors - construction, business, nursing, menufacturing. Send us enquiry to know more and join us to get a TITP Visa.",
            btn: "Enroll"
        },
        {
            name: "Skilled Worker",
            img: img8,
            para: 'Skilled worker VISA is also called SSW. In April 2019, Japan established a new status of residence, "Specified Skilled Worker (SSW)", to welcome capable specialists from overseas countries to work in certain Japanese industrial fields, to function as workers ready to take on jobs without prior training. ',
            btn: "Book now"
        },
        {
            name: "IT Engineering Jobs ",
            img: img9,
            para: "We collaborate with the best Japanese language schools across Japan. Our coordinators will help you pick a program that fits your learning preferences and future study goals. We also support you to get admission in other courses for master, phd and bachelors. ",
            btn: "Book now"
        }
    ]
    const latestNews = [
        {
            title: "Birthday Celebration",
            date: "13 Dec 2022",
            paragraph: " Thank you everybody, especially Cho san from Korea, to make my day spacial. Although I turned 29 this year, I feel younger and energatic when I am with you people.",
        },
        {
            title: "Completion of NSAI Research",
            date: "10 Dec 2022",
            paragraph: " I am happy to announce that I have completed the Neuro Symbolic AI research with the collaboration of Professor Rafal Hokkaido University. I'll update once the article will be published.",
        },
        {
            title: "Completion of NSAI Research",
            date: "4 Dec 2022",
            paragraph: "I am happy to announce that I have completed the Neuro Symbolic AI research with the collaboration of Professor Rafal Hokkaido University. I'll update once the acticle will be published.",
        },
        {
            title: "Certification from The Academy of Modern Applied Psychology",
            date: "20 Nov 2022",
            paragraph: "It is my houner to receive a certificate from Kain Ramsay for the 'Lafe Coaching course'.",
        },
        {
            title: "Research proposal has been finalized",
            date: "03 Oct 2022",
            paragraph: "The research proosal has been finalized on the topic 'Embodying a SMARTMedical Assistant' for 2023 research. Look for research section for detailed information. ",
        },
        {
            title: "Business Japanese",
            date: "24 August 2022",
            paragraph: "Rabinandan Kishor has taken BJT certification course and obtained a score of 398.",
        },
        {
            title: "Certification from Transformation Services",
            date: "03 May 2022",
            paragraph: "I'm happy to announce I have earned a certificate of 'Relationship coaching'. The course was conducted by Joeel & Natalia.",
        }
    ]
    return (
        <div>
            <div className='md:px-20 px-5'>
                <Banner japanese></Banner>

                <p className='px-4 text-lg font-semibold mb-10' id='work'>We are an NGO center working effectively for human development. We support you to achieve all your goals in Japan. We are also attributed with highly qualified instructors for teaching Japanese language. We also provide jobs and immigration services for describing candidates to Japan.</p>

                {/* enrollment */}

                <div className=' grid md:grid-cols-2 grid-cols-1' id='immigrate'>
                    <Enrollment id='free-consult' japanese></Enrollment>
                    <Announcement title='Announcement'></Announcement>
                </div>
                {/* services */}
                <div id='services'>
                    <h2 className=' text-2xl lg:text-3xl text-slate-400 font-semibold mb-5 border-b-2 border-cyan-500'>Services</h2>
                    <div className='grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-5'>
                        {
                            services.map((s, index) => <div key={index} className=' bg-slate-100 rounded lg:p-5 p-3'>
                                <img className=' w-full h-[150px]' src={s.img} alt="" />
                                <h3 className='text-[#2A1B3D] font-bold text-lg text-center my-2'>{s.name}</h3>
                                <p className=''>{s.para}</p>
                                <div className=' mx-auto text-center'>
                                    <a href="#enroll_japanese">
                                    <button className='mt-2 py-1 px-3 text-center bg-sky-600 rounded text-white mx-auto'>{s.btn}</button></a>
                                </div>
                            </div>)
                        }
                        </div>
                        {/* <div className='grid xl:grid-cols-4 lg:grid-cols-2 grid-cols-1 gap-5 mt-5'>
                        {
                            services.slice(4).map((s, index) => <div key={index} className=' bg-slate-100 rounded lg:p-5 p-3'>
                                <img className=' w-full lg:h-[150px] h-auto' src={s.img} alt="" />
                                <h3 className='text-[#2A1B3D] font-bold text-lg text-center my-2'>{s.name}</h3>
                                <p className='lg:h-[150px] xl:h-[300px] '>{s.para}</p>
                                <div className=' mx-auto text-center'>
                                    <button className='mt-2 py-1 px-3 text-center bg-sky-600 rounded text-white mx-auto'>{s.btn}</button>
                                </div>
                            </div>)
                        }
                    </div> */}
                </div>
                {/* about japan */}
                <About id='about-japan' title='About Japan' para='Japan is an island country in East Asia. It is situated in the northwest Pacific Ocean, and is bordered on the west by the Sea of Japan, while extending from the Sea of Okhotsk in the north toward the East China Sea, Philippine Sea, and Taiwan in the south.' img='https://img.freepik.com/free-photo/asian-woman-wearing-japanese-traditional-kimono-yasaka-pagoda-sannen-zaka-street-kyoto-japan_335224-40.jpg?w=2000' />

                <About title='About JLPT Test' jlpt />

                <About title='About BJT' para='It is very important to understand business Japanese before you plan to move or work in Japan. Japan is a very polite and sensitive country and in different settings, like business, casual, they speak differently. We teach you business Japanese and business adequately and help you to get a good score in BJT.' img={img2} />     

                <Latest btn='All news' all latestNews={latestNews}></Latest>

            </div>
        </div >
    );
};

export default Japanese;
